import React, { useContext } from "react";
import { Route, Routes, Navigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

import NotificationAlert from "react-notification-alert";

import AdminNavbar from "components/Navbars/AdminNavbar.js";
import Footer from "components/Footer/Footer.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import FixedPlugin from "components/FixedPlugin/FixedPlugin.js";

import logo from "assets/img/react-logo.png";
import Protected from "components/common/ProtectedRoute";
import { UserContextProvider } from "context/UserContext";
import PATHS from "constant/paths";
import useRoutes from "routes";
import { applyOrder, mergeOrder } from "utils/menuOrder";
import { SaveMenuOrderAPI } from "network/user";
import { ErrorToaster } from "components/common/toast";
import NotFound from "views/NotFound";

var ps;

const Admin = (props) => {
  const { t } = useTranslation("nav");
  const { user, setUser, sections } = useContext(UserContextProvider);
  const combinedRoutes = useRoutes();

  const [activeColor, setActiveColor] = React.useState("blue");
  const [sidebarMini, setSidebarMini] = React.useState(true);
  const [opacity, setOpacity] = React.useState(0);
  const [sidebarOpened, setSidebarOpened] = React.useState(false);
  const mainPanelRef = React.useRef(null);
  const notificationAlertRef = React.useRef(null);
  const location = useLocation();
  React.useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    if (mainPanelRef.current) {
      mainPanelRef.current.scrollTop = 0;
    }
  }, [location]);
  // React.useEffect(() => {
  //   let innerMainPanelRef = mainPanelRef;
  //   if (navigator.platform.indexOf("Win") > -1) {
  //     document.documentElement.classList.add("perfect-scrollbar-on");
  //     document.documentElement.classList.remove("perfect-scrollbar-off");
  //     ps = new PerfectScrollbar(mainPanelRef.current);
  //     mainPanelRef.current &&
  //       mainPanelRef.current.addEventListener("ps-scroll-y", showNavbarButton);
  //     let tables = document.querySelectorAll(".table-responsive");
  //     for (let i = 0; i < tables.length; i++) {
  //       ps = new PerfectScrollbar(tables[i]);
  //     }
  //   }
  //   window.addEventListener("scroll", showNavbarButton);
  //   return function cleanup() {
  //     if (navigator.platform.indexOf("Win") > -1) {
  //       ps.destroy();
  //       document.documentElement.classList.add("perfect-scrollbar-off");
  //       document.documentElement.classList.remove("perfect-scrollbar-on");
  //       innerMainPanelRef.current &&
  //         innerMainPanelRef.current.removeEventListener(
  //           "ps-scroll-y",
  //           showNavbarButton
  //         );
  //     }
  //     window.removeEventListener("scroll", showNavbarButton);
  //   };
  // }, []);
  // const showNavbarButton = () => {
  //   if (
  //     document.documentElement.scrollTop > 50 ||
  //     document.scrollingElement.scrollTop > 50 ||
  //     (mainPanelRef.current && mainPanelRef.current.scrollTop > 50)
  //   ) {
  //     setOpacity(1);
  //   } else if (
  //     document.documentElement.scrollTop <= 50 ||
  //     document.scrollingElement.scrollTop <= 50 ||
  //     (mainPanelRef.current && mainPanelRef.current.scrollTop <= 50)
  //   ) {
  //     setOpacity(0);
  //   }
  // };
  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.collapse) {
        return getRoutes(prop.views);
      }
      if (prop.linkOnly) {
        return null; // voce solo del menu: la pagina e' gia' registrata altrove
      }
      if (prop.layout === "/admin") {
        return (
          <Route path={prop.path} element={prop.component} key={key} exact />
        );
      } else {
        return null;
      }
    });
  };
  // Titolo in alto per le pagine condivise tra aree (carte, stampa, style): dipende da ?type= o ?area=.
  const areaBrand = () => {
    const path = location.pathname.replace(/\/$/, "");
    const q = new URLSearchParams(location.search);
    const kind = q.get("type") || q.get("area");
    const names = {
      drinks: t("brand.drinksCards"),
      menu: t("brand.foodCards"),
      food: t("brand.foodCards"),
      booking: t("brand.bookings"),
      order: t("brand.orders"),
    };
    if (!names[kind]) return null;
    const cards = path.endsWith("/menu-cards") || path.endsWith("/menu-cards/print");
    return cards || path.endsWith("/style") ? names[kind] : null;
  };
  // Titolo della barra in alto: la voce del menu con il percorso piu' lungo che corrisponde alla pagina
  // (cosi' /bookings/statistics mostra "Statistics" e non "My Bookings").
  const getActiveRoute = (routes) => {
    const currentPath = location.pathname;
    let best = null;
    let bestLength = -1;
    const walk = (list) => (list || []).forEach((route) => {
      if (route.collapse) {
        walk(route.views);
        return;
      }
      const routePath = route.path;
      if (!routePath || route.linkOnly) return;
      const matches = routePath.includes(":")
        ? new RegExp(`^${routePath.replace(/:\w+/g, "[^/]+")}$`).test(currentPath)
        : currentPath.indexOf(routePath) !== -1;
      if (matches && routePath.length > bestLength) {
        best = route.name;
        bestLength = routePath.length;
      }
    });
    walk(routes);
    return best || "Default Brand Text";
  };

  const handleActiveClick = (color) => {
    setActiveColor(color);
  };
  const handleMiniClick = () => {
    if (document.body.classList.contains("sidebar-mini")) {
      setSidebarMini(false);
    } else {
      setSidebarMini(true);
    }
    document.body.classList.toggle("sidebar-mini");
  };
  const toggleSidebar = () => {
    setSidebarOpened(!sidebarOpened);
    document.documentElement.classList.toggle("nav-open");
  };
  const closeSidebar = () => {
    setSidebarOpened(false);
    document.documentElement.classList.remove("nav-open");
  };
  const hasModule = (r) =>
    !r.requiresModule || (user?.modules || []).includes(r.requiresModule);
  const filteredRoutes = combinedRoutes
    .filter(hasModule)
    .map((route) => {
      if (route.views) {
        const filteredViews = route.views.filter(
          (view) =>
            hasModule(view) &&
            (!view.allowedRoles ||
              view.allowedRoles.some(
                (role) =>
                  role?.toLowerCase()?.trim() ===
                  user?.role?.toLowerCase()?.trim()
              ))
        );
        return filteredViews.length > 0
          ? { ...route, views: filteredViews }
          : null;
      }
      return !route.allowedRoles ||
        route.allowedRoles.some(
          (role) =>
            role?.toLowerCase()?.trim() === user?.role?.toLowerCase()?.trim()
        )
        ? route
        : null;
    })
    .filter(Boolean);

  const saveMenuOrder = async (visible) => {
    const order = mergeOrder(visible, user?.menu_order);
    try {
      await SaveMenuOrderAPI(order);
      setUser((u) => ({ ...u, menu_order: order }));
      return true;
    } catch (e) {
      ErrorToaster(t("sidebar.saveOrderFailed"));
      return false;
    }
  };

  return (
    <Protected>
      <div className="wrapper">
        <div className="rna-container">
          {/* <NotificationAlert ref={notificationAlertRef} /> */}
        </div>
        <div className="navbar-minimize-fixed" style={{ opacity: opacity }}>
          <button
            className="minimize-sidebar btn btn-link btn-just-icon"
            onClick={handleMiniClick}
          >
            <i className="tim-icons icon-align-center visible-on-sidebar-regular text-muted" />
            <i className="tim-icons icon-bullet-list-67 visible-on-sidebar-mini text-muted" />
          </button>
        </div>

        <Sidebar
          {...props}
          routes={applyOrder(filteredRoutes, user?.menu_order)}
          onSaveOrder={saveMenuOrder}
          activeColor={activeColor}
          logo={{
            outterLink: PATHS.DASHBOARD,
            text: "Risto Platform",
            imgSrc: logo,
          }}
          closeSidebar={closeSidebar}
        />

        <div className="main-panel" ref={mainPanelRef} data={activeColor}>
          <AdminNavbar
            {...props}
            handleMiniClick={handleMiniClick}
            brandText={
              areaBrand() ||
              (getActiveRoute(filteredRoutes) === "Default Brand Text"
                ? t("brand.default")
                : getActiveRoute(filteredRoutes))
            }
            sidebarOpened={sidebarOpened}
            toggleSidebar={toggleSidebar}
          />
          <Routes>
            {getRoutes(filteredRoutes)}
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            {/* <Route path="*" element={<NotFound />} /> */}
          </Routes>
          {/* {props?.location?.pathname?.indexOf("full-screen-map") !==
          -1 ? null : (
            <Footer fluid />
          )} */}
        </div>
        {/* <FixedPlugin
          activeColor={activeColor}
          sidebarMini={sidebarMini}
          handleActiveClick={handleActiveClick}
          handleMiniClick={handleMiniClick}
        /> */}
      </div>
    </Protected>
  );
};

export default Admin;
